<header id="page-topbar">
    <div class="navbar-header">

<div class="d-flex">

    <div class="navbar-brand-box">
      <a href="/" class="logo logo-dark">
        <span class="logo-sm">
          <img src="assets/images/logo.svg" alt="" height="22">
        </span>
        <span class="logo-lg">
          <img src="assets/images/logo-niubiz.png" alt="" height="17">
        </span>
      </a>

      <a href="/" class="logo logo-light">
        <span class="logo-sm">
          <img src="assets/images/logo-niubiz.png" alt="" height="22">
        </span>
        <span class="logo-lg">
          <img src="assets/images/logo-niubiz.png" alt="" height="19">
        </span>
      </a>
    </div>
    
  </div>
</div>
</header>

<div class="account-pages my-5 pt-5">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="text-center mb-5">
                    <h1 class="text-uppercase">Cierre de sesión exitoso</h1>
                    <h3 class="">Vuelva pronto</h3>

                    <p></p><p></p>
                    <div class="mt-5 text-center">
                        <a class="btn btn-primary" href="/">Volver al Dashboard</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-8 col-xl-6">
                <div>
                    <img src="assets/images/error-img.png" alt="" class="img-fluid">
                </div>
            </div>
        </div>
    </div>
</div>